module.exports = __webpack_public_path__ + "img/sg.02c30a9e.png";